import { create } from "zustand";

export const useWebsocket = create((set) => {
    return {
        connection: false,
        setConnection: (connection) => set({connection: connection}),
    };
});
